<template>
  <div class="ushk-rili_content J_rili_content">
    <!-- 标题 -->
    <div class="ushk-rili_content-h">
      <h3 class="ushk-rili_content-title"><span></span>{{ option.title }}</h3>
      <p v-if="['港股时段', '美股盘前', '美股盘后'].includes(option.title)" class="ushk-rili_content-desc">EPS采用的是归属于股东/母公司、（稀释后）每股收益；净利润采用的是GAAP/IFRS会计准则下的净利润</p>
    </div>
    <div class="ushk-rili_content-b">
      <div class="ushk-table">
        <div class="ushk-table-head J_rili_table_head">
          <div data-type="fixed">
            <div class="ushk-table-head_wrap">
              <div
                v-for="(item, index) in option.items"
                :key="index"
                :style="{width: item[1]}"
                class="ushk-table-head_item"
              >
                {{ item[0] }}
              </div>
            </div>
          </div>
        </div>
        <table class="ushk-table_body">
          <colgroup>
            <col
              v-for="(item, index) in option.items"
              :key="index"
              :width="item[1]"
            />
          </colgroup>
          <component
            :is="option.name"
            :datas="datas"
            :none-text="option.noneText"
            :type="option.type"
          ></component>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import EconomicsList from './EconomicsList'
import EventsList from './EventsList'
import HolidayList from './HolidayList'
export default {
  components: {
    EconomicsList,
    EventsList,
    HolidayList
  },
  props: {
    datas: {
      type: [Array, Boolean],
      default: false
    },
    type: String
  },
  data () {
    return {
      options: {
        economics: {
          title: '经济数据一览',
          name: 'EconomicsList',
          isFilter: true,
          type: 'economics',
          items: [
            ['时间', '7%'],
            ['国/区', '5%'],
            ['指标名称', '34%'],
            ['重要性', '10%'],
            ['前值', '8%'],
            ['预测值', '8%'],
            ['公布值', '9%'],
            ['影响', '13%']
          ]
        },
        stockHk: {
          title: '港股时段',
          name: 'EconomicsList',
          type: 'stock',
          noneText: '今日无股票财报数据',
          items: [
            ['时间', '7%'],
            ['交易所', '8%'],
            ['指标名称', '31%'],
            ['重要性', '10%'],
            ['前值', '8%'],
            ['预测值', '8%'],
            ['公布值', '9%'],
            ['影响', '13%']
          ]
        },
        stockPre: {
          title: '美股盘前',
          name: 'EconomicsList',
          type: 'stock',
          noneText: '今日无股票财报数据',
          items: [
            ['时间', '7%'],
            ['交易所', '8%'],
            ['指标名称', '31%'],
            ['重要性', '10%'],
            ['前值', '8%'],
            ['预测值', '8%'],
            ['公布值', '9%'],
            ['影响', '13%']
          ]
        },
        stockAfter: {
          title: '美股盘后',
          name: 'EconomicsList',
          type: 'stock',
          noneText: '今日无股票财报数据',
          items: [
            ['时间', '7%'],
            ['交易所', '8%'],
            ['指标名称', '31%'],
            ['重要性', '10%'],
            ['前值', '8%'],
            ['预测值', '8%'],
            ['公布值', '9%'],
            ['影响', '13%']
          ]
        },
        events: {
          title: '财经大事一览',
          name: 'EventsList',
          type: 'events',
          items: [
            ['时间', '8%'],
            ['国/区', '10%'],
            ['城市', '15%'],
            ['重要性', '12%'],
            ['事件', '47%']
          ]
        },
        holiday: {
          title: '假期休市一览',
          name: 'HolidayList',
          type: 'holiday',
          items: [
            ['时间', '15%'],
            ['国/区', '15%'],
            ['市场', '20%'],
            ['节日名称', '15%'],
            ['详细安排', '35%']
          ]
        },
        stock: {
          title: '股票财报',
          name: 'EconomicsList',
          type: 'stock',
          noneText: '今日无股票财报数据',
          items: [
            ['时间', '7%'],
            ['交易所', '8%'],
            ['指标名称', '31%'],
            ['重要性', '10%'],
            ['前值', '8%'],
            ['预测值', '8%'],
            ['公布值', '9%'],
            ['影响', '13%']
          ]
        }
      }
    }
  },
  computed: {
    option () {
      return this.type ? this.options[this.type] : {}
    }
  },
  created () {}
}
</script>



// WEBPACK FOOTER //
// ListGroup.vue?cdd83fca